class DayOfWeek {
  constructor(name, abbr, number) {
    this.name = name;
    this.abbr = abbr;
    this.day_of_week = number;
  }
}

export const DAYS_OF_WEEK = [
  new DayOfWeek('Sunday', 'Sun', 0),
  new DayOfWeek('Monday', 'Mon', 1),
  new DayOfWeek('Tuesday', 'Tue', 2),
  new DayOfWeek('Wednesday', 'Wed', 3),
  new DayOfWeek('Thursday', 'Thur', 4),
  new DayOfWeek('Friday', 'Fri', 5),
  new DayOfWeek('Saturday', 'Sat', 6),
];

export const DAYS_OF_WORK_WEEK = [
  new DayOfWeek('Monday', 'Mon', 1),
  new DayOfWeek('Tuesday', 'Tue', 2),
  new DayOfWeek('Wednesday', 'Wed', 3),
  new DayOfWeek('Thursday', 'Thur', 4),
  new DayOfWeek('Friday', 'Fri', 5),
];



/** WEBPACK FOOTER **
 ** ./javascripts/common/values/days_of_week.js
 **/